import ArrowDropDownSharpIcon from '@material-ui/icons/ArrowDropDownSharp';
import { components } from 'react-select';

var CaretDownIcon = () => {
  return <ArrowDropDownSharpIcon />;
};

var DropdownIndicator = (props: any) => {
  return (
    <components.DropdownIndicator {...props}>
      <CaretDownIcon />
    </components.DropdownIndicator>
  );
};

export default DropdownIndicator;
